import { useEffect } from 'react';

const PaymentCancel = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://stgstdpay.inicis.com/stdjs/INIStdPay_close.js';
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);
};
export default PaymentCancel;
